<template>
  <v-layout
    align-center
    justify-end
  >
    <v-flex shrink>
      <v-btn
        v-show="!expand"
        color="primary"
        flat
        icon
        @click="expand = true"
      >
        <v-icon>search</v-icon>
      </v-btn>
    </v-flex>
    <v-flex shrink>
      <v-expand-x-transition>
        <div
          v-show="expand"
        >
          <v-text-field
            v-model="search"
            autofocus
            width="350"
            solo
            prepend-inner-icon="search"
            name="search"
            placeholder="search"
            clearable
          >
            <v-btn
              slot="append"
              color="primary"
              flat
              @click="cancel"
            >
              close
            </v-btn>
          </v-text-field>
        </div>
      </v-expand-x-transition>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'SearchWidget',
  model: {
    prop: 'input',
    event: 'change'
  },
  prop: {
    input: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      search: '',
      expand: false
    };
  },
  watch: {
    input: {
      handler(val) {
        if (val === '') return;
        this.search = val;
      }
    },
    search: {
      handler(val) {
        this.$emit('change', val);
      }
    },
    expand: {
      handler(val) {
        this.$emit('expand', val);
      }
    }
  },
  methods: {
    cancel() {
      this.expand = false;
      this.search = '';
    }
  }
};
</script>

